import { deepFreeze } from '../../utils/misc_utils';

export const CartEventActionEnum = deepFreeze({
    CREATE: {
        value: 'CREATE',
        label: 'Utwórz'
    },
    ADD_PURCHASE_PRODUCT: {
        value: 'ADD_PURCHASE_PRODUCT',
        label: 'Dodaj produkt'
    },
    ADD_PRODUCT_FAIL: {
        value: 'ADD_PRODUCT_FAIL',
        label: 'Błąd podczas dodawania produktu'
    },
    ADD_RESERVATION_PRODUCT: {
        value: 'ADD_RESERVATION_PRODUCT',
        label: 'Dodaj produkt do rezerwacji'
    },
    REMOVE_PRODUCT: {
        value: 'REMOVE_PRODUCT',
        label: 'Usuń produkt'
    },
    CHANGE_STATUS: {
        value: 'CHANGE_STATUS',
        label: 'Zmień status'
    },
    REFRESH: {
        value: 'REFRESH',
        label: 'Odśwież'
    },
    RECREATE: {
        value: 'RECREATE',
        label: 'Utwórz na nowo'
    },
    FINALIZE: {
        value: 'FINALIZE',
        label: 'Sfinalizuj'
    },
    CLEAR: {
        value: 'CLEAR',
        label: 'Wyczyść'
    }
});

export const OrderStatusEnum = deepFreeze({
    CANCELED: {
        value: 'CANCELED',
        label: 'Anulowany'
    },
    CREATED: {
        value: 'CREATED',
        label: 'Nowy'
    },
    IN_REALIZATION: {
        value: 'IN_REALIZATION',
        label: 'W realizacji'
    },
    WAITING_FOR_PAYMENT: {
        value: 'WAITING_FOR_PAYMENT',
        label: 'Oczekiwanie na płatność'
    },
    FINISHED: {
        value: 'FINISHED',
        label: 'Zakończony'
    },
    FAIL_PAYMENT: {
        value: 'FAIL_PAYMENT',
        label: 'Nieudana płatność'
    },
    FAIL_UPDATE_POD_RESOURCE: {
        value: 'FAIL_UPDATE_POD_RESOURCE',
        label: 'Błąd aktualizacji towaru'
    },
    PARTIALLY_RETURNED: {
        value: 'PARTIALLY_RETURNED',
        label: 'Częściowy zwrot'
    },
    RETURNED: {
        value: 'RETURNED',
        label: 'Zwrot'
    },
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    }
});

export const PaymentTypeEnum = deepFreeze({
    ADDED_CARD: {
        value: 'ADDED_CARD',
        label: 'Karta z aplikacji'
    },
    ONLINE: {
        value: 'ONLINE',
        label: 'Płatność online'
    },
    TERMINAL: {
        value: 'TERMINAL',
        label: 'Terminal płatniczy'
    },
    DEDUCT_FROM_SALARY: {
        value: 'DEDUCT_FROM_SALARY',
        label: 'Pobranie z wynagrodzenia'
    },
    NO_REQUIRED: {
        value: 'NO_REQUIRED',
        label: 'Płatność niewymagana'
    },
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    }
});
